import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Schema from 'async-validator';
import store from '@/redux';
import { ConfigProvider } from 'antd';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import './style/main.scss';
import './style-antd/main.less';

// async validator stop the validation warnings...
Schema.warning = () => {};

ReactDOM.render(
    // <React.StrictMode> // ant design is full of strict mode errors so for the sake of the devs
    <Provider store={store}>
        <ConfigProvider
            getPopupContainer={(trigger) => trigger?.parentElement}
        >
            <App />
        </ConfigProvider>
    </Provider>,
    // </React.StrictMode>,
    document.getElementById('main-wrapper'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
